/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import DetectAmp from 'components/DetectAmp';
import adInjector from 'util/ads/injector';
import memoize from 'memoize-one';
import { HAS_ADS } from 'constants/site';

export default WrappedComponent => {
  class WithAds extends Component {
    injectAds = memoize((_bundles, _type, _isAmp) =>
      adInjector(_bundles || [], _type, _isAmp)
    );
    render() {
      if (HAS_ADS === false) {
        // Ads are disabled for this site
        return <WrappedComponent {...this.props} />;
      }
      return (
        <DetectAmp>
          {isAmp => {
            const { contentBundles, ...rest } = this.props;
            let injected;
            if (contentBundles) {
              injected = this.injectAds(
                contentBundles,
                this.props.pageType,
                isAmp
              );
            }
            return <WrappedComponent contentBundles={injected} {...rest} />;
          }}
        </DetectAmp>
      );
    }
  }
  return WithAds;
};
